export const execAsync = ({ gen, action, log, name = 'ExecAsync', delay = 0 }) => {
    let canceled = false;
    let calls = 0;
    const timeoutAction = () => {
        const { done, value } = gen.next();
        calls++;
        log && console.debug(`${name}`, { calls, canceled, done, value });
        if (done || canceled)
            return;
        action(value);
        setTimeout(timeoutAction, delay);
    };
    setTimeout(timeoutAction, delay);
    return {
        cancel: () => {
            canceled = true;
        },
    };
};
export const combine = (...ops) => ({
    cancel: () => ops.map(o => o.cancel()),
});
export const getViewportWidth = () => (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0));
export const maybe = (fn) => (i) => {
    if (!i)
        return;
    return fn(i);
};
export const once = (fn) => {
    let called = false;
    let result;
    return (...args) => {
        if (!called) {
            result = fn(...args);
            called = true;
        }
        return result;
    };
};
export const runAll = (...fns) => (...i) => {
    fns.forEach(fn => fn(...i));
};
export const tap = (fnToWrap, opts) => (...i) => {
    opts.before?.(...i);
    const result = fnToWrap?.(...i);
    opts.after?.(...i);
    return result;
};
//# sourceMappingURL=utils.js.map